import styled from "styled-components";

export const NotificationContentStyled = styled.div``;
